import {EFormJobType, EJobPriority, EJobProgress} from '../models'

export const constantJobTypeList: Record<EFormJobType, string> = {
  [EFormJobType.TEXT]: 'Text Field',
  [EFormJobType.MULTIPLE_CHOICE]: 'Multiple Choice',
  [EFormJobType.DROPDOWN]: 'Dropdown',
  [EFormJobType.IMAGE]: 'Image',
  [EFormJobType.MULTIPLE_IMAGES]: 'Multiple Images',
  [EFormJobType.DATE]: 'Date',
  [EFormJobType.TIME]: 'Time',
}

export const constantJobPriority: Record<EJobPriority, string> = {
  [EJobPriority.LOW]: 'Rendah',
  [EJobPriority.NORMAL]: 'Normal',
  [EJobPriority.HIGH]: 'Tinggi',
  [EJobPriority.CRITICAL]: 'Kritis',
}

export const constantJobProgress: Record<EJobProgress, string> = {
  [EJobProgress.CLOSED]: 'Disetujui',
  [EJobProgress.COMPLETED]: 'Menunggu Persetujuan',
  [EJobProgress.DRAFT]: 'Draf',
  [EJobProgress.IN_PROGRESS]: 'Berlangsung',
  [EJobProgress.OPEN]: 'Terbuka',
  [EJobProgress.REJECTED]: 'Ditolak',
  [EJobProgress.SUBMITTED]: 'Berlangsung',
  [EJobProgress.SCHEDULED]: 'Tejadwal',
}

export const formJobTypeOpt = Object.entries(constantJobTypeList).map(([key, label]) => ({
  value: key as EFormJobType,
  label,
}))
